import React, { useState } from 'react';
import { getCurrentClass, getShapeStyles } from '../../../CardFrameCollection/utils';
import { isMobileDevice } from 'src/components/WidgetMaker/WidgetDnD/isMobileDevice';
import { COMMON_LAYOUT_TYPE } from '../Testimonials/Constants';
import { ORIGINAL_IMAGE_WIDTH, STATIC_IMAGE_PATH } from './constant';
import { useLoadVisibleReel } from '../../hooks/useLoadVisibleReel';
import classNames from 'classnames';
import { isVideoUrl } from 'src/components/DesignSystem/ModernTheme/utils/videoUtility';
import contentAnimationStyle from '@/components/DesignSystem/AtomicDesignsUtilities/ContentAnimationStyles.module.scss';

export function CarouselGridItem(props) {
  const {
    videoRef,
    data,
    index,
    listPresentation,
    cardFrame,
    oneGridCellGeometry,
    handleImageClick,
  } = props;
  const { layoutName, imageWidth } = listPresentation;
  const [loadVideo, setLoadVideo] = useState(false);

  useLoadVisibleReel({ videoRef, reelIndex: index, setLoadVideo, loadVideo });

  const shapeStyleCalculated = getShapeStyles(
    cardFrame?.imageShape,
    oneGridCellGeometry?.width
  );
  const shapeStyle = shapeStyleCalculated[0];
  const isMobile = isMobileDevice();
  const imageURL = data?.imageUrl;

  const getStyleAccToLayout = () => {
    if (
      layoutName === COMMON_LAYOUT_TYPE.ONE ||
      (layoutName === COMMON_LAYOUT_TYPE.TWO && imageWidth !== ORIGINAL_IMAGE_WIDTH)
    ) {
      return {
        width: oneGridCellGeometry.width,
        height: oneGridCellGeometry.height,
        minHeight: 100,
      };
    }
    return {
      maxWidth: oneGridCellGeometry.width * 1.8,
      height: oneGridCellGeometry.height,
      minHeight: 100,
    };
  };
  const styleAccToLayout = getStyleAccToLayout();

  return (
    <div
      onClick={() => handleImageClick(index)}
      key={index}
      className="tw-cursor-pointer"
    >
      <div
        style={{ ...styleAccToLayout, ...shapeStyle.style }}
        className={classNames('tw-overflow-hidden', shapeStyle.className)}
      >
        {isVideoUrl(imageURL) ? (
          <video
            ref={(node) => (videoRef[index] = node)}
            className={'tw-z-10 tw-h-full tw-w-full tw-object-cover'}
            loop
            autoPlay
            playsInline={true}
            muted={true}
            src={loadVideo ? imageURL : undefined}
          />
        ) : (
          <img
            src={imageURL || STATIC_IMAGE_PATH}
            style={styleAccToLayout}
            loading="lazy"
            decoding="async"
            className={classNames(
              !isMobile
                ? contentAnimationStyle[getCurrentClass(cardFrame?.hoverEffect)]
                : '',
              'tw-object-cover'
            )}
          />
        )}
      </div>
    </div>
  );
}
